var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSeatIcon = function SvgSeatIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#seat-icon_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M13.862 16.538a.606.606 0 0 1 0 1.21h-7.7a.606.606 0 0 1 0-1.21zm.228 1.43a.9.9 0 0 1-.228.03l.088-.004a1 1 0 0 0 .14-.027m.624-.737-.005.03.005-.036zm-.764-.938.08.012zM2.562.34a2.32 2.32 0 0 1 2.852 1.52l1.491 4.472c.17.51.648.854 1.186.854h2.723a.581.581 0 0 1 0 1.162H8.138c-.75 0-.316.736-.078 1.447a1.1 1.1 0 0 0 1.043.752h5.615l.228.012a2.32 2.32 0 0 1 1.41.667l.154.17c.337.412.524.93.524 1.468l-.011.23a2.32 2.32 0 0 1-2.305 2.087H4.45a.61.61 0 0 1-.588-.458L.97 3.158v-.003l-.047-.22A2.32 2.32 0 0 1 2.562.34m9.083 7.427"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "seat-icon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h18v18H0z"
  })))));
};
export default SvgSeatIcon;